import { createSelector } from 'reselect'
import { getConfiguration } from 'redux/configuration/selectors'
import { getAvailableFiltersResponsive } from 'redux/availableFilters/selectors'
import { isItemLocked } from '../aside/selectors'

const getToolbarActions = createSelector(
    getConfiguration,
    (state, toolbar) => toolbar,
    (configuration, toolbar) => configuration.toolbars[toolbar] || []
)

export const getBottomToolbarActions = createSelector(
    getAvailableFiltersResponsive,
    state => getToolbarActions(state, 'bottom'),
    (filters, actions) => [ [ ...filters ], ...actions ]
)

export const getLeftToolbarActions = createSelector(
    state => getToolbarActions(state, 'left'),
    actions => actions
)

export const isItemDisplayable = createSelector(
    (state, item) => {
        return (
            typeof(item.action) === "function"
            && (
                typeof(item.isDisplayed) !== "function"
                || item.isDisplayed(state)
            )
        )
    },
    (isItemDisplayable) => isItemDisplayable,
)

export const isItemDisabled = createSelector(
    (state, toolbarName, item) => isItemLocked(state, toolbarName, item),
    (state, toolbarName, item) => typeof(item.isDisabled) === 'function' && item.isDisabled(state),
    (isLocked, isDisabled) => isLocked || isDisabled
)

export const retrieveValueFromToolbar = createSelector(
    (state, toolbar, key, defaultValue) => {

        if(typeof(toolbar[key]) === 'function')
        {
            return toolbar[key](state)
        }

        if(toolbar[key] !== undefined)
        {
            return toolbar[key]
        }

        return defaultValue
    },
    value => value
)
